export enum PaymentStatusSeverity {
	paid = "success",
	unpaid = "warning",
}
